import { ADD_CAPABILITIES, ADD_CARD_PROGRAM, CARDS_SET_LOADING, CARD_PROGRAMS_SET_LOADING, REMOVE_CARD_PROGRAM, SET_CARDS, SET_CARDS_SEARCH_PARAMS, SET_CARD_PROGRAM, SET_CARD_PROGRAMS, SET_CARD_PROGRAM_CARD_COUNTS } from '@Actions/cardsActionsConstants';
import { DEFAULT_DATA_GRID_LIMIT } from '@Shared/grid';
export const defaultState = {
    programs: [],
    capabilities: {},
    loading: false,
    loaded: false,
    counts: {},
    cards: [],
    cardsTotal: 0,
    cardsPaginationParams: {
        page: 0,
        pageSize: DEFAULT_DATA_GRID_LIMIT,
        sortField: 'created_at',
        sortDirection: 'desc',
        filters: {},
        search: ''
    },
    searchParams: {},
    cardsLoading: true
};
export function cardsReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_CARD_PROGRAMS:
            return Object.assign(Object.assign({}, state), { programs: action.payload, loaded: true });
        case SET_CARD_PROGRAM:
            return Object.assign(Object.assign({}, state), { programs: state.programs.map((program) => (program.id === action.payload.id ? action.payload : program)), loading: false });
        case ADD_CARD_PROGRAM:
            return Object.assign(Object.assign({}, state), { programs: [...state.programs, action.payload], loading: false });
        case SET_CARDS:
            return Object.assign(Object.assign({}, state), { cards: action.payload.cards, cardsTotal: action.payload.total, cardsPaginationParams: action.payload.paginationParams });
        case SET_CARDS_SEARCH_PARAMS:
            return Object.assign(Object.assign({}, state), { searchParams: action.payload });
        case REMOVE_CARD_PROGRAM:
            return Object.assign(Object.assign({}, state), { programs: state.programs.filter((program) => program.id !== action.payload) });
        case SET_CARD_PROGRAM_CARD_COUNTS:
            return Object.assign(Object.assign({}, state), { counts: action.payload });
        case ADD_CAPABILITIES:
            return Object.assign(Object.assign({}, state), { capabilities: Object.assign(Object.assign({}, state.capabilities), action.payload) });
        case CARD_PROGRAMS_SET_LOADING:
            return Object.assign(Object.assign({}, state), { loading: action.payload });
        case CARDS_SET_LOADING:
            return Object.assign(Object.assign({}, state), { cardsLoading: action.payload });
        default:
            return state;
    }
}
